var map = {
	"./accountingandbookkeeping.json": [
		2868,
		2868
	],
	"./advisoryservices.json": [
		2033,
		2033
	],
	"./businessregistration.json": [
		4677,
		4677
	],
	"./companysecretarialservices.json": [
		5140,
		5140
	],
	"./estateplanning.json": [
		215,
		215
	],
	"./gst.json": [
		6824,
		6824
	],
	"./internationaltaxation.json": [
		4068,
		4068
	],
	"./mergerandacquisition.json": [
		56,
		56
	],
	"./onlineaccounting.json": [
		1424,
		1424
	],
	"./payrollmanagement.json": [
		7700,
		7700
	],
	"./permitsandlicense.json": [
		4666,
		4666
	],
	"./saleofpropertyinindia.json": [
		1157,
		1157
	],
	"./taxcompliances.json": [
		7101,
		7101
	],
	"./taxlitigation.json": [
		4557,
		4557
	],
	"./valuation.json": [
		6085,
		6085
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1895;
module.exports = webpackAsyncContext;